@if(turning === player.player_id && allStatus$.isPassBoll && !isTransitioning){
    <div class="d-flex align-items-center justify-content-center" style="width: 100%;background-color: #FFF;padding-bottom: 24px;border-radius: 0 0 24px 24px;margin-top: -18px;padding-top: 18px;">
        <button type="button" (click)="passTheBoll()" class="to-pass-the-ball" [disabled]="!allStatus$.isPassBoll || !rdUse.connected() || !rdUse.gameStateReady() || isTransitioning">
            @if(players.players.length > 1){
                {{ 'dice.txtButtonTwo' | translate }}
            }@else{
                {{ 'dice.txtButtonTwoOnePlayer' | translate }}
            }
    </button>
    </div>
}
